export enum HowPaid {
    ByCash = "C",
    SalaryAccount = "S"
}